import { TeamMember } from '../types';

export const team: TeamMember[] = [
  {
    id: 1,
    name: 'Tammy Brooks',
    title: 'Founder & Principal Designer',
    bio: 'With over 15 years of experience in interior design, Tammy founded Harmony Home Decor with a vision to make professional design accessible to everyone. She holds a degree in Interior Architecture and is certified by the American Society of Interior Designers.',
    image: 'https://images.pexels.com/photos/5704849/pexels-photo-5704849.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 2,
    name: 'David Chen',
    title: 'Senior Design Consultant',
    bio: 'David specializes in modern and minimalist design approaches. His background in architecture gives him a unique perspective on space utilization and structural possibilities.',
    image: 'https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 3,
    name: 'Lisa Martinez',
    title: 'Color & Textile Specialist',
    bio: 'Lisa has an exceptional eye for color combinations and textile selection. She helps clients find the perfect balance between aesthetics and functionality in their fabric choices.',
    image: 'https://images.pexels.com/photos/3586798/pexels-photo-3586798.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  }
];